<template>
  <div>
    <scout-members
      :member-objects="scoutedMemberObjects"
      :contract-id="Number($route.params.contractId)"
      :job-id="Number($route.params.jobId)"
      display-key="scouted"
      data-test="scout-members"
      :count="count"
      :count-limit="countLimit"
      @fetch="fetch"
    />
  </div>
</template>

<script>
import ScoutMembers from '@/components/organisms/ScoutMembers.vue'
import Indicator from '@/lib/indicator'

const PAGING_LIMIT = process.env.PAGING_LIMIT

export default {
  components: {
    ScoutMembers
  },
  data () {
    return {
      scoutedMembers: [],
      countLimit: Number(PAGING_LIMIT),
      count: 0
    }
  },
  computed: {
    scoutedMemberObjects () {
      return this.scoutedMembers.map((scoutedMember) => {
        return {
          id: scoutedMember.id,
          member: scoutedMember
        }
      })
    }
  },
  watch: {
    $route: {
      handler () {
        this.fetch()
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch (page = 1) {
      Indicator.emitShow()
      this.fetchScoutedCount().then(response => {
        this.$set(this, 'count', response.data)
        this.fetchScoutedMembers(page)
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    async fetchScoutedMembers (page = 1) {
      await this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/scouted_users/pages/${page}`)
        .then(async (response) => {
          if (response.data.length === 0 && page !== 1) {
            // 1ページ目以外で0件だった場合には再取得する(Elasticsearch連携ラグ対策)
            await this.fetchScoutedMembers()
            return
          }
          this.setProperty(response.data)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (scoutedMembers) {
      this.$set(this, 'scoutedMembers', scoutedMembers)
    },
    fetchScoutedCount () {
      return this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/scouted_users/_count`)
    }
  }
}
</script>
